

.fieldset {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 1rem;
    border-radius: 0.5rem;

    legend {
        font-weight: bold;
        font-size: larger;
        padding: 0.25rem;
        border-radius: 0.5rem;
    }

    &.borderless {
        border: none;
        padding: 0;
        border-radius: 0;

        legend {
            padding: 0;
        }
    }


}
